import { styled } from '@linaria/react'

export const CardsContainerSC = styled.div<{ children: React.ReactNode }>`
  height: auto;
  max-width: 100%;

  display: flex;
  flex-wrap: wrap;
  width: 100%;
`
